function decodeBase64Url(value) {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = `${base64}${"=".repeat((4 - (base64.length % 4)) % 4)}`;
  const binary = atob(padded);
  return decodeURIComponent(
    Array.from(binary, (char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")
  );
}

export function decodeAccessToken(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    return JSON.parse(decodeBase64Url(part));
  } catch {
    return null;
  }
}

export function getStoredLoginStatus() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return {};
    const user = JSON.parse(raw);
    const payload = decodeAccessToken(user?.access_token);
    if (!payload?.sub) return {};
    if (payload.exp && payload.exp * 1000 < Date.now()) return {};
    if (payload.is_verified === false) return {};
    const fullname = typeof user?.profile_fullname === "string"
      ? user.profile_fullname.trim()
      : "";
    return fullname ? { ...payload, fullname } : payload;
  } catch {
    return {};
  }
}

export function updateStoredFullname(fullname) {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return;
    const user = JSON.parse(raw);
    user.profile_fullname = (fullname || "").trim();
    localStorage.setItem("user", JSON.stringify(user));
  } catch {
    // The in-memory session can still be updated by the caller.
  }
}
